import { Module, PATH_DICTS_AGREEMENT_COMPANIES } from "@/constants";
import { fetchAgreementCompanyList } from "@/services/agreementCompany";
import { forwardRef } from "react";
import { ControllerRenderProps } from "react-hook-form";
import { useTranslation } from "react-i18next";
import AsyncSelect, { Option } from "./AsyncSelect";
import { EntityListLink } from "./EntityListLink";
import appConfiguration from "./cfg/AppCfg";

interface AgreementCompanySelectProps extends ControllerRenderProps {
  className?: string;
  defaultItem?: Partial<Option>;
}

export default forwardRef<HTMLButtonElement, AgreementCompanySelectProps>(
  function AgreementCompanySelect({ defaultItem, ...props }, ref) {
    const { t } = useTranslation();

    return (
      <span className="flex items-start gap-1">
        <span className="flex-1">
          <AsyncSelect
            queryKey={[Module.AgreementCompanies]}
            queryFn={() =>
              fetchAgreementCompanyList({
                limit: appConfiguration.selectComponentsPaginationLimit,
              })
            }
            enableFilter={false}
            placeholder={t("agreementCompanySelect.placeholder")}
            loadingLabel={t("agreementCompanySelect.loadingCompanies")}
            {...props}
            ref={ref}
            className="w-full"
            defaultItem={defaultItem}
          />
        </span>

        <EntityListLink
          path={PATH_DICTS_AGREEMENT_COMPANIES}
          label={t("agreementCompanySelect.link")}
        />
      </span>
    );
  },
);
